import { NavigationLinkInterface } from '../types';

export const STATION_MANAGEMENT_COMPONENT_NAME = 'StationManagement';

const navigationLinks: NavigationLinkInterface[] = [
	{
		name: i18n => i18n.sideBar.pd,
		path: '/personal-details',
		image: '/lulav-icons/user-icon-greener.svg',
		cubeText: i18n => i18n.pNav.pd,
		componentName: 'PersonalDetails'
	},
	{
		name: i18n => i18n.sideBar.od,
		path: '/purchases',
		image: '/lulav-icons/file.svg',
		cubeText: i18n => i18n.pNav.purchases,
		componentName: 'Purchases',
	},
	{
		name: i18n => i18n.sideBar.sd,
		path: '/station-details',
		image: '/lulav-icons/station.svg',
		cubeText: i18n => i18n.pNav.station,
		componentName: 'StationDetails',
	},
	{
		name: i18n => i18n.sideBar.sm.sm,
		path: '/station-management',
		image: '/lulav-icons/station-manager.svg',
		cubeText: i18n => i18n.pNav.stationM,
		componentName: STATION_MANAGEMENT_COMPONENT_NAME,
		showStationStatus: true,
		subLinks: [
			{
				name: i18n => i18n.sideBar.sm.o,
				path: '/purchases'
			},
			{
				name: i18n => i18n.sideBar.sm.sd,
				path: '/details'
			},
			{
				name: i18n => i18n.sideBar.sm.fs,
				path: '/free-sale'
			}
		]
	},
	{
		name: i18n => i18n.sideBar.am,
		path: '/association-management',
		image: '/lulav-icons/regular-heart.svg',
		cubeText: i18n => i18n.pNav.associationM,
		componentName: 'AssociationManagement'
	},
	{
		name: i18n => i18n.at.title,
		path: '/advertising-management',
		image: '/lulav-icons/megaphone.svg',
		cubeText: i18n => i18n.at.title,
		componentName: 'AdvertisingManagement'
	}
];

export default navigationLinks;